import axios from '../axiosConfig'; // Assuming this is your configured Axios instance
import { API_BASE_URL } from '../config';
const baseURL = API_BASE_URL;

const getEvents = async () => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.get('/events/list', {
      headers: headers
    }); 
    return response;
  } catch (error) {
    console.error('Error fetching event content:', error);
    return null;
  }
}; 
const addNewEvent = async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.post('/events/add', data, {
      headers: headers
    });
    console.log('response from backend', response); 
    return response;
  } catch (error) {
    return error;
  }
};
const updateEvent = async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try { 
    const response = await axios.put(`/events/${data.id}`, {data}, {
      headers: headers
    });
    console.log('response from backend', response);
    return response;
  } catch (error) {
    console.error('Error fetching protected content:', error);
  }
};1
const deleteEvent = async  (id) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.delete(`/events/${id}`, {
      headers: headers
    });
    console.log('response from backend', response);
    return response;
  } catch (error) {
    console.error('Error fetching protected content:', error);
  }
};
const getCategories = async () => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.get('/calendar/getCategories', {
      headers: headers
    });
    console.log(response);
    return response.result;
  } catch (error) {
    console.error('Error fetching event content:', error);
    return null;
  }
}; 
const getUpCommingEvent = async () => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.get('/calendar/getUpCommingEvent', {
      headers: headers
    });
    console.log(response);
    return response.result;
  } catch (error) {
    console.error('Error fetching event content:', error);
    return null;
  }
}; 

const getOEMList = async (data) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.get('/oem/list?page='+data.page+'&per_page='+data.per_page ,{
      headers: headers
    });
    console.log(response);
    return response;
  } catch (error) { 
    return error;
  }
}; 

const getOEMById = async (id) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.get(`/oem/single/${id}`, {
      headers: headers
    });
    console.log(response);
    return response;
  } catch (error) { 
    return error;
  }
}; 

const getEventById = async (id) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.get(`/events/${id}`, {
      headers: headers
    });
    console.log(response);
    return response;
  } catch (error) {
    console.error('Error fetching event content:', error);
    return error;
  }
};

// Event Ticket Management APIs
const createEventTickets = async (eventId, ticketData) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.post(`/events/tickets/${eventId}/bulk`, ticketData, {
      headers: headers
    });
    console.log('Event tickets created:', response);
    return response;
  } catch (error) {
    console.error('Error creating event tickets:', error);
    return error;
  }
};

const updateEventTickets = async (eventId, ticketData) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.post(`/events/tickets/${eventId}/bulk`, ticketData, {
      headers: headers
    });
    console.log('Event tickets updated:', response);
    return response;
  } catch (error) {
    console.error('Error updating event tickets:', error);
    return error;
  }
};

const getEventTicketLines = async (eventId) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.get(`/events/ticket-lines?event_id=${eventId}`, {
      headers: headers
    });
    console.log('Event ticket lines:', response);
    return response;
  } catch (error) {
    console.error('Error fetching event ticket lines:', error);
    return error;
  }
};

const deleteEventTickets = async (eventId) => {
  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    const response = await axios.delete(`/events/tickets/${eventId}/bulk`, {
      headers: headers
    });
    console.log('Event tickets deleted:', response);
    return response;
  } catch (error) {
    console.error('Error deleting event tickets:', error);
    return error;
  }
};

export { 
  baseURL,
  getEventById,
  getEvents, 
  addNewEvent,
  updateEvent,
  deleteEvent,
  getCategories,
  getUpCommingEvent,
  getOEMList,
  getOEMById,
  createEventTickets,
  updateEventTickets,
  getEventTicketLines,
  deleteEventTickets
};